export default __webpack_public_path__ + "525d8ec10b62ccdfb27f8db26af2ff6f.svg";